'use strict';

var novicell = novicell || {};

novicell.accordion = novicell.accordion || new function () {
    const accordionTriggers = document.querySelectorAll('.js-accordion-item-trigger');
    const accordionImages = document.querySelectorAll('.js-accordion-item-image');
    const itemOpenClass = 'accordion-item--open';
    const imageOverlaySelector = '.js-accordion-image-overlay-content';
    const accordionImageOverlay = document.querySelector(imageOverlaySelector);

    this.init = function () {
        if (!accordionTriggers && accordionTriggers.length <= 0) {
            return;
        }

        for (let i = 0; i < accordionTriggers.length; i++) {
            let currentTrigger = accordionTriggers[i];

            currentTrigger.addEventListener('click', function(event) {
                openAccordionItem(event);
            });
        }

        if(!accordionImages && accordionImages.length <= 0) {
            return;
        }

        for (let i = 0; i < accordionImages.length; i++) {
            let currentImage = accordionImages[i];

            currentImage.addEventListener('click', function() {
                openImageInOverlay();
            });
        }
    };

    function openAccordionItem(e) {
        let triggerItem = e.currentTarget;
        let parent = triggerItem.parentNode;

        if(novicell.helper.hasClass(parent, itemOpenClass)) {
            closeItem(parent);

        } else {
            // closeAllItemsInAccordion(parent.parentNode);
            openItem(parent);
        }
    }

    function closeAllItemsInAccordion(accordion) {
        let openItems = accordion.querySelectorAll('.js-accordion-item.accordion-item--open');

        for (let i = 0; i < openItems.length; i++) {
            let currentItem = openItems[i];

            closeItem(currentItem);
        }
    }

    function openItem(item) {
        item.classList.add(itemOpenClass);
    }

    function closeItem(item) {
        item.classList.remove(itemOpenClass);
    }

    function openImageInOverlay() {
        let imageClicked = event.currentTarget.querySelector('img');
        let overlayImage = accordionImageOverlay.querySelector('img');

        overlayImage.setAttribute('data-src', imageClicked.getAttribute('src'));

        novicell.overlay.create({
            'class': 'accordion-image-overlay',
            'selector': imageOverlaySelector
        });
    }
};
